import _ from 'lodash';
import worldMap from '../core/map';
import { pinBuilder } from '../core/map/pinBuilder';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';

import HaloLayer from './HaloLayer';
import Leaflet from './Leaflet';

const LayerControls = (name) => require('../controls').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./index').default.get(name, currentMap);
};

const name = 'PointOfInterest';

class PointOfInterestLayer {
    constructor (currentMap) {
        const mapId = +currentMap._id;

        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_pi.png`;

        const onClick = (feature, layer) => {
            LayerControls(name).highlight(layer);
            LayerControls(name).show({
                show: true,
                id: feature.properties.Id
            });

            return new HaloLayer(currentMap, layer, feature, name, 'points');
        };

        const onComplete = (features) => {
            try {
                if (LayerControls('Voronoi').getControls(mapId).switch.onOff.status) { LayerControls('Voronoi').update(mapId); }
            } catch (error) {
                console.log('Layer not avaliable');
            }

            return LayerControls(name).show({
                show: false,
                refresh: true
            });
        };

        const onRemove = (features) => {
            try {
                if (LayerControls('Voronoi').getControls(mapId).switch.onOff.status) { return LayerControls('Voronoi').update(mapId); }
            } catch (error) {
                console.log('Layer not avaliable');
            }
        };

        const onMoveend = () =>
            LayerControls(name).show({ refresh: true }, get(name, currentMap).getCurrentFeatures());

        const clusterTemplate = (cluster) => {
            const data = { value: cluster.getChildCount() };

            return pinBuilder.create.pin.imageWithValue(data, clusterImage);
        };

        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            remote: {
                method: 'GET',
                url: `${environment.get('API_HOST')}/pointOfInterest`
            },
            scaleRange: [5, 20],
            filter: {
                location: true
            },
            showAll: false,
            autofocus: false,
            uniqueField: 'Id',
            sort: 'Nome',
            click: onClick,
            done: onComplete,
            remove: onRemove,
            dragend: onMoveend,
            zoomend: onMoveend,
            type: 'cluster',
            symbology: {
                type: 'polymorph',
                cluster: {
                    template: clusterTemplate
                },
                heat: {
                    theme: ColorBrewer.getHeatColors('Greens')
                },
                style: {
                    icon: {
                        fields: ['Tipo', 'Blocked'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_ponto_de_interesse.png`,
                        iconSize: [50, 64], // size of the icon
                        iconAnchor: [25, 60], // point of the icon which will correspond to marker's location
                        labelAnchor: [25, -32]
                    },
                    riseOnHover: true
                }
            }
        });
    }
}

export default PointOfInterestLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/PointOfInterestLayer.js